import { makeActionCreator } from '../../../../../utilities'
import { BurnsConstants } from './burns.constants'

export const selectedBurnExam = makeActionCreator(BurnsConstants.SET_SELECTED_BURN_TYPE, 'isTBSA')
export const setBurnExams = makeActionCreator(BurnsConstants.SET_BURNS_EXAM, 'burnsExamData')
export const setBurnColors = makeActionCreator(BurnsConstants.SET_COLOR_STATE, 'burnsColorData')
export const setBodyAreaCalculations = makeActionCreator(BurnsConstants.SET_BODY_AREA_CALCULATION)
export const setBodyView = makeActionCreator(BurnsConstants.SET_BODY_VIEW, 'bodyView')
export const setBurnsTotalCalculations = makeActionCreator(
  BurnsConstants.SET_TOTAL_BURNS_CALCULATIONS,
  'totalBurnsCalculations'
)
export const setBurnType = makeActionCreator(BurnsConstants.SET_BURN_TYPE, 'burnType')
export const setSingedNasalHair = makeActionCreator(BurnsConstants.SET_SINGED_NASAL_HAIR, 'singedNasalHair')
export const setCarbonInMouth = makeActionCreator(BurnsConstants.SET_CARBON_IN_MOUTH, 'carbonInMouth')
export const setPoorVentilation = makeActionCreator(BurnsConstants.SET_POOR_VENTILATION, 'poorVentilation')
export const setCoLevel = makeActionCreator(BurnsConstants.SET_CO_LEVEL, 'coLevel')
export const setCurrentSelectedObj = makeActionCreator(BurnsConstants.SET_CURRENT_SELECTED_OBJ, '__currentSelectedObj')
export const setRange = makeActionCreator(BurnsConstants.SET_RANGE, '__range')
export const saveBurns = makeActionCreator(BurnsConstants.SAVE_BURNS)
export const setBurns = makeActionCreator(BurnsConstants.SET_BURNS, 'burns')
export const resetBurns = makeActionCreator(BurnsConstants.RESET_BURNS)
export const resetBurnsTbsa = makeActionCreator(BurnsConstants.RESET_BURNS_TBSA)
